import { render, staticRenderFns } from "./addThemeContent.vue?vue&type=template&id=1a23a70e&lang=pug"
import script from "./addThemeContent.vue?vue&type=script&lang=js"
export * from "./addThemeContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports